import { Application } from '@hotwired/stimulus';
import ProductController from 'aura/product-controller';
import ProductFormController from 'aura/product-form-controller';
import GalleryController from 'aura/gallery-controller';
import MediaController from 'aura/media-controller';
import CartController from 'aura/cart-controller';
import PairOfferController from 'aura/pair-offer-controller';
import NavigationController from 'aura/navigation-controller';
import DialogController from 'aura/dialog-controller';
import MotionController from 'aura/motion-controller';
import RevealController from 'aura/reveal-controller';
import StickyPurchaseController from 'aura/sticky-purchase-controller';
import StoryRailController from 'aura/story-rail-controller';
import { startMotionPreferences } from 'aura/motion-preferences';
import { setupEditor } from 'aura/editor';

// One application, with behaviours scoped to the owning section/form.
export const application = Application.start();
for (const [name, controller] of Object.entries({
  product: ProductController,
  'product-form': ProductFormController,
  gallery: GalleryController,
  media: MediaController,
  cart: CartController,
  'pair-offer': PairOfferController,
  navigation: NavigationController,
  dialog: DialogController,
  motion: MotionController,
  reveal: RevealController,
  'sticky-purchase': StickyPurchaseController,
  'story-rail': StoryRailController,
}))
  application.register(name, controller);
startMotionPreferences();
let studyModule;
const loadStudy = () => {
  studyModule ||= import('aura/object-study-controller')
    .then((module) => application.register('object-study', module.default))
    .catch(() => {
      studyModule = null;
    });
};
const studyObserver =
  'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          for (const entry of entries)
            if (entry.isIntersecting) {
              studyObserver.unobserve(entry.target);
              loadStudy();
            }
        },
        { rootMargin: '600px' },
      )
    : null;
function enhance(root) {
  const matching = (selector) => [
    ...(root.matches?.(selector) ? [root] : []),
    ...root.querySelectorAll(selector),
  ];
  matching('[data-story-carousel]').forEach((element) => {
    const controllers = new Set((element.dataset.controller || '').split(' ').filter(Boolean));
    controllers.add('story-rail');
    element.dataset.controller = [...controllers].join(' ');
  });
  matching('[data-controller~="object-study"]').forEach((element) => {
    if (studyObserver && !globalThis.Shopify?.designMode) studyObserver.observe(element);
    else loadStudy();
  });
}
enhance(document);
setupEditor(enhance);
